export const MOOD_EMOJIS = ['😔', '😕', '😐', '🙂', '😊'];

export const MOOD_LABELS = [
  { value: 1, label: 'Very Low', emoji: '😔', bgColor: 'bg-red-100', borderColor: 'border-red-500' },
  { value: 2, label: 'Low', emoji: '😕', bgColor: 'bg-orange-100', borderColor: 'border-orange-500' },
  { value: 3, label: 'Neutral', emoji: '😐', bgColor: 'bg-yellow-100', borderColor: 'border-yellow-500' },
  { value: 4, label: 'Good', emoji: '🙂', bgColor: 'bg-lime-100', borderColor: 'border-lime-500' },
  { value: 5, label: 'Great', emoji: '😊', bgColor: 'bg-green-100', borderColor: 'border-green-500' }
];

export const MOOD_CONTEXTS = [
  { id: 'studying', label: 'Studying', icon: '📚' },
  { id: 'social', label: 'Social', icon: '👥' },
  { id: 'financial', label: 'Financial', icon: '💰' },
  { id: 'health', label: 'Health', icon: '🏃' },
  { id: 'sleep', label: 'Sleep', icon: '😴' },
  { id: 'family', label: 'Family', icon: '👨‍👩‍👧' }
];

export const ROUTES = {
  LOGIN: '/login',
  DASHBOARD: '/dashboard',
  MOOD: '/mood',
  FOCUS: '/focus',
  INSIGHTS: '/insights',
  RESOURCES: '/resources',
  SETTINGS: '/settings'
};